// extracted by mini-css-extract-plugin
export var divider = "_xs-0";